import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {NgbModal, NgbModalConfig} from '@ng-bootstrap/ng-bootstrap';
import {AuthService, EchoService, SettingsService} from '@customcoding/shared';
import {TabConfig} from "./tickets/event/event-list/event-list.component";
import {VolunteerService} from "./goldenme/volunteer/volunteer.service";
import {EventService} from "./tickets/event/event.service";
import {FooterService} from "@customcoding/core";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [NgbModalConfig, NgbModal]
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {

    lang = new Subject<string>();
    title = 'dashboard-app';
    demo = false;

    constructor(
        private pushService: EchoService,
        private settings: SettingsService,
        private volunteerService: VolunteerService,
        private ngbModalConfig: NgbModalConfig,
        private authService: AuthService,
        private eventService: EventService,
        private footerService: FooterService
    ) {
        this.setUpNGBConfigs();
    }


    ngOnInit(): void {
        this.demo = this.settings.get('BETA');

        this.footerService.footerNav.set([
            {
                text: 'footer.contact',
                iconClass: 'la-contact',
                link: 'https://goldenme.lu/kontakt/'
            }
        ])

    }

    ngAfterViewInit() {
        this.authService.getCurrentUserAsync().then(user => {

            const volunteerTabs: TabConfig[] = [
                {
                    icon: 'la la-user-check',
                    titleKey: 'tickets.event.tab.my',
                    filterLogic: (filter) => ({...filter, volunteerStatus: 'CONFIRMED'})
                },
                {
                    icon: 'la la-user-clock',
                    titleKey: 'tickets.event.tab.unconfirmed',
                    filterLogic: (filter) => ({...filter, volunteerStatus: 'UNCONFIRMED'})
                },
                {
                    icon: 'la la-calendar-times',
                    titleKey: 'tickets.event.tab.declined',
                    filterLogic: (filter) => ({...filter, volunteerStatus: 'DECLINED'})
                }
            ];

            this.volunteerService.isVolunteer().then(isVolunteer => {
                if (isVolunteer) {
                    this.eventService.registerTabs(volunteerTabs);
                }
            })

        })

    }

    ngOnDestroy() {
        this.pushService.leavePushChannel();
    }

    private setUpNGBConfigs() {
        this.ngbModalConfig.scrollable = true;
    }

}
